// expenses utils

export const get_expense_status_name = (id, expense_status) => {
	let status = expense_status.find(status => status.id === id);
	return status ? status.name : '';
}